(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alivium-cart-extras"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-alivium-upsell-button]');
    if (!button) return;
    event.preventDefault();
    button.disabled = true;
    const originalContent = button.innerHTML;
    button.textContent = 'Agregando…';

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer && cartDrawer.getSectionsToRender
        ? cartDrawer.getSectionsToRender().map((section) => section.id)
        : ['cart-drawer', 'cart-icon-bubble'];
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'No se pudo agregar');
      if (cartDrawer && cartDrawer.renderContents) {
        cartDrawer.renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      button.textContent = 'Reintentá';
      window.setTimeout(() => {
        button.innerHTML = originalContent;
        button.disabled = false;
      }, 1800);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alivium-encabezado-loop"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var bars = document.querySelectorAll('[data-alv-cyber]');
      if (!bars.length) return;
      var now = Date.now();
      bars.forEach(function (bar) {
        var start = Date.parse(bar.dataset.start);
        var end = Date.parse(bar.dataset.end);
        var label = bar.querySelector('[data-alv-cyber-label]');
        var dates = bar.querySelector('[data-alv-cyber-dates]');
        var target;
        if (now > end) {
          bar.hidden = true;
          document.querySelectorAll('[data-alv-cyber-item]').forEach(function (el) { el.hidden = true; });
          return;
        }
        if (now >= start) {
          target = end;
          if (label) label.textContent = 'Ya empezó · termina en';
          if (dates) dates.textContent = 'Masajeador 25% OFF · hasta el 8/11';
          document.querySelectorAll('[data-alv-cyber-ticker]').forEach(function (el) { el.textContent = 'Cyber Alivium: masajeador Recover Pro 25% OFF hasta el 8 de noviembre'; });
          document.querySelectorAll('[data-alv-cyber-only]').forEach(function (el) { el.hidden = false; });
        } else {
          target = start;
        }
        var diff = Math.max(0, Math.floor((target - now) / 1000));
        bar.querySelector('[data-d]').textContent = pad(Math.floor(diff / 86400));
        bar.querySelector('[data-h]').textContent = pad(Math.floor((diff % 86400) / 3600));
        bar.querySelector('[data-m]').textContent = pad(Math.floor((diff % 3600) / 60));
        bar.querySelector('[data-s]').textContent = pad(diff % 60);
      });
    }
    tick();
    window.setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alivium-parches-producto"] && !Shopify.designMode) return;
  try {
    function initializeAliviumPatchUpsells() {
    const upsells = document.querySelectorAll('[data-alivium-parches-producto]:not([data-ready="true"])');

    upsells.forEach((upsell) => {
      upsell.dataset.ready = 'true';

      const button = upsell.querySelector('.alivium-parches-compacto__boton');
      const variantId = Number(upsell.dataset.variantId);
      const root = window.Shopify?.routes?.root || '/';

      const markAsAdded = () => {
        button.textContent = '✓ Agregado';
        button.disabled = true;
      };

      const getCart = async () => {
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin' });
        if (!response.ok) throw new Error('No se pudo consultar el carrito');
        return response.json();
      };

      const isInCart = (cart) => cart.items.some((item) => Number(item.variant_id) === variantId);

      getCart().then((cart) => {
        if (isInCart(cart)) markAsAdded();
      }).catch(() => {});

      button.addEventListener('click', async () => {
        button.disabled = true;
        button.textContent = 'Agregando…';

        try {
          const cart = await getCart();

          if (isInCart(cart)) {
            markAsAdded();
            return;
          }

          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });

          if (!response.ok) throw new Error('No se pudo agregar el producto');

          markAsAdded();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (error) {
          button.textContent = 'Reintentar';
          button.disabled = false;
        }
      });
    });
  }

  initializeAliviumPatchUpsells();
  document.addEventListener('shopify:section:load', initializeAliviumPatchUpsells);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alivium-sticky-cart"] && !Shopify.designMode) return;
  try {
    const initAliviumStickyCart = () => {
    document.querySelectorAll('.alivium-sticky-cart').forEach((bar) => {
      if (bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';

      const section = bar.closest('.shopify-section');
      const originalButton = section ? section.querySelector('.product-form__submit') : document.querySelector('.product-form__submit');
      const stickyButton = bar.querySelector('.alivium-sticky-cart__button');
      const ratingSlot = bar.querySelector('.alivium-sticky-cart__rating');
      const ratingSource = section ? section.querySelector('.alivium-rating') : null;

      if (!originalButton || !stickyButton) {
        bar.remove();
        return;
      }

      if (ratingSource && ratingSlot) {
        const clone = ratingSource.cloneNode(true);
        clone.removeAttribute('href');
        ratingSlot.append(clone);
      }

      const updateStickyCart = () => {
        const rect = originalButton.getBoundingClientRect();
        const buttonOnScreen = rect.top < window.innerHeight && rect.bottom > 0;
        const shouldShow = !buttonOnScreen;
        bar.classList.toggle('is-visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        stickyButton.disabled = originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true';
      };

      stickyButton.addEventListener('click', () => {
        if (!stickyButton.disabled) originalButton.click();
      });

      window.addEventListener('scroll', updateStickyCart, { passive: true });
      window.addEventListener('resize', updateStickyCart);
      new MutationObserver(updateStickyCart).observe(originalButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      updateStickyCart();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAliviumStickyCart);
  } else {
    initAliviumStickyCart();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["corrector-offer-selector"] && !Shopify.designMode) return;
  try {
    function initializeAliviumBundleSelectors(root = document) {
    root.querySelectorAll('[data-alivium-bundle-selector]').forEach((selector) => {
      if (selector.dataset.initialized === 'true') return;

      const productInfo = selector.closest('product-info');
      const quantityInput = productInfo?.querySelector('input[name="quantity"]');
      const radios = selector.querySelectorAll('input[type="radio"]');

      if (!quantityInput || radios.length === 0) return;

      const updateQuantity = (radio) => {
        quantityInput.value = radio.value;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

        selector.querySelectorAll('.alivium-bundle-option').forEach((option) => {
          option.classList.toggle('is-selected', option.contains(radio));
        });
      };

      radios.forEach((radio) => {
        radio.addEventListener('change', () => updateQuantity(radio));
      });

      const selectedRadio = selector.querySelector('input[type="radio"]:checked');
      if (selectedRadio) updateQuantity(selectedRadio);

      selector.dataset.initialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAliviumBundleSelectors());
  } else {
    initializeAliviumBundleSelectors();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAliviumBundleSelectors(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
